export default __webpack_public_path__ + "static/media/candado_c.5a49ef23.png";